/* eslint-disable no-unused-vars */
import { MouseEvent } from 'react';
import { searchType } from 'features/searchSchedule/models/searchType';
import { OptionHistoryLabel } from 'features/searchSchedule/ui';
import { formatFullnameToUppercase } from 'shared/lib';

export const makeHistoryOptionLabel = (
  searchType: searchType,
  item: string,
  handleOptionClearClick: (
    e: MouseEvent<HTMLButtonElement>,
    value: string,
    teacherId?: string,
  ) => void,
  teacherId?: string,
) => {
  const styledValue = formatFullnameToUppercase(item);
  return searchType === 'main' ? (
    <OptionHistoryLabel
      value={styledValue}
      onClick={(e) => handleOptionClearClick(e, item, teacherId)}
    />
  ) : (
    <OptionHistoryLabel
      styleText={{ fontSize: 16 }}
      styleBtn={{ width: 20, height: 20 }}
      styleImg={{ width: 23, height: 23 }}
      value={styledValue}
      onClick={(e) => handleOptionClearClick(e, item, teacherId)}
    />
  );
};
